module.exports = __webpack_public_path__ + "static/media/send-your-photos.679bb5ac.png";